/**
 * What each editor's save hands its host, the same on both platforms: the
 * room editor's room, and the floor plan view's changed rooms, each in its
 * optimized form (`getOptimizedFloorPlan`).
 */
import { type FloorPlanRoom, getOptimizedFloorPlan } from '@kaiizen/kai-floor-plan';
import type { AssemblyRoom } from '../assembler';
import type { FloorPlanAssemblerState } from './FloorPlanAssemblerState';
import type { FloorPlanEditorState } from './FloorPlanEditorState';

/** The room editor's save: the room shown, optimized. */
export const roomToSave = ({ stRef }: FloorPlanEditorState): FloorPlanRoom => getOptimizedFloorPlan(stRef.current.shape);

/** The floor plan view's save: every room that changed since the last save, optimized. */
export const changedRoomsToSave = ({ changedRooms }: FloorPlanAssemblerState): AssemblyRoom[] =>
  changedRooms.map(assemblyRoom => ({ ...assemblyRoom, room: getOptimizedFloorPlan(assemblyRoom.room) }));
